import {useCallback} from "react";
import {UpdateCallGroupMutationVariables} from "./queries.generated";
import {GroupsQuery, useGroupsQuery} from "@/queries.generated";
import {DomainOutgoingCallBarrings, useDomainOutgoingCallBarringsQuery} from "@/hooks";

const createInitialData = (data: GroupsQuery["groups"]["items"][number]): UpdateCallGroupMutationVariables => ({
    id: data.id,
    name: data.name,
    type: data.group,
    pickup: data.pickup,
    sequentialTimeout: data.sequentialTimeout,
    outgoingCallBarringAdmin: data.outgoingCallBarringAdmin,
    outgoingCallBarringOperator: data.outgoingCallBarringOperator,
    size: data.size,
});

export type DataSource = {
    loading: boolean;
    refetch: () => Promise<UpdateCallGroupMutationVariables>;

    group: UpdateCallGroupMutationVariables;
    domainCallBarrings: DomainOutgoingCallBarrings;
};

export const useDataSource = (groupId: number, domainId: number): DataSource => {
    const groupQuery = useGroupsQuery({
        variables: {id: groupId},
        fetchPolicy: "no-cache",
    });

    const domainCallBarringsQuery = useDomainOutgoingCallBarringsQuery(domainId);

    const refetch = useCallback(
        async () => createInitialData((await groupQuery.refetch()).data.groups.items[0]),
        [groupQuery],
    );

    if (groupQuery.loading || domainCallBarringsQuery.loading)
        return {
            loading: true,
            refetch,
            group: undefined,
            domainCallBarrings: {
                admin: [],
                operator: [],
            },
        };

    return {
        loading: false,
        refetch,
        group: createInitialData(groupQuery.data.groups.items[0]),
        domainCallBarrings: domainCallBarringsQuery.domainOutgoingCallBarrings,
    };
};
